export const getData = (snapshot, options) => {
    return {
        ...snapshot.data(options),
        id: snapshot.id,
    };
};
//# sourceMappingURL=data.js.map